import React from 'react';
import { useSelector } from 'react-redux';
import { RootState } from '@/store';
import PriceDisplay from '../shared/PriceDisplay';

type PropsType = {
  availableForSale: boolean;
};

const ButtonTitle = ({ availableForSale }: PropsType) => {
  const { cartButtonState } = useSelector((state: RootState) => state.cart);
  if (!availableForSale) return <>Out of stock</>;
  if (cartButtonState) {
    return (
      <>
        {cartButtonState.charAt(0).toLocaleUpperCase() + cartButtonState.slice(1)}
        <PriceDisplay />
      </>
    );
  }
  return (
    <>
      Add to cart <PriceDisplay />
    </>
  );
};

export default ButtonTitle;
